module.exports = __webpack_public_path__ + "static/media/serverside-ai-logo.7e81c59a.svg";